module.exports = __webpack_public_path__ + "static/media/food.9df0e40d.svg";